module.exports = __webpack_public_path__ + "img/entertainment-chairs-chaises.b3d4d8e.jpg";